export const estimatePriceConstants = {
  ESTIMATE_SHIPMENT_PRICE_REQUEST: 'ESTIMATE_PRICE_ESTIMATE_SHIPMENT_PRICE_REQUEST',
  ESTIMATE_SHIPMENT_PRICE_SUCCESS: 'ESTIMATE_PRICE_ESTIMATE_SHIPMENT_PRICE_SUCCESS',
  ESTIMATE_ASSEMBLY_PRICE_REQUEST: 'ESTIMATE_PRICE_ESTIMATE_ASSEMBLY_PRICE_REQUEST',
  ESTIMATE_ASSEMBLY_PRICE_SUCCESS: 'ESTIMATE_PRICE_ESTIMATE_ASSEMBLY_PRICE_SUCCESS',
}
